module.exports = __webpack_public_path__ + "media/assets/images/placeholder-headcut-a174681caf98fec8dff01f59c596d0c6.png";